import { connect } from 'react-redux';
import { compose } from 'redux';
import { getAreas } from '../redux/store/appData/areas';
import { getBookings } from '../redux/store/userData/bookings/actions';
import { getCarEquipments } from '../redux/store/appData/carEquipments';
import { setInitialMapContent } from '../redux/store/ui/map';
import { getCategories } from '../redux/store/carsSearch';
import { getServices } from '../redux/store/service';
import { getRentalData } from '../redux/store/userData/rental';
import { CLIENT_TYPE } from '../@types';
import { UserDataOutput, State } from '../@types';
import { getPaymentMethods } from '../redux/store/userData/user/actions';

export type Props = {
  user: UserDataOutput | null | undefined;
  getAreas: typeof getAreas;
  getRentalData: typeof getRentalData;
  getBookings: typeof getBookings;
  loadingRentalData: boolean;
  getCarEquipments: typeof getCarEquipments;
  getServices: typeof getServices;
  setInitialMapContent: typeof setInitialMapContent;
  lastKnownLocation: Location | null | undefined;
  getCategories: typeof getCategories;
  getPaymentMethods: typeof getPaymentMethods;
};

const withData: any = compose(
  connect(
    ({
      networkStatus: { activities },
      device: { lastKnownLocation },
    }: State) => ({
      loadingRentalData: activities.some((activityType: string) =>
        [CLIENT_TYPE.RENTAL_CLIENT.GET_RENTAL_DATA].includes(activityType)
      ),
      lastKnownLocation,
    }),
    {
      getAreas,
      getRentalData,
      getBookings,
      getCarEquipments,
      getServices,
      setInitialMapContent,
      getCategories,
      getPaymentMethods,
    }
  )
);
export default withData;
